import { ApiError } from '../../api';
import type { RidebookEntry } from '@kontor/shared';

const dateTime = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

export const when = (iso: unknown): string => (typeof iso === 'string' && iso ? dateTime.format(new Date(iso)).replace(',', '') : '–');
export const text = (v: unknown): string => (typeof v === 'string' ? v : '');
export const euro = (cents: unknown): string => (typeof cents === 'number' ? `${(cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €` : '–');

/** Zeitpunkt aus dem Feld „Datum und Uhrzeit“ des Browsers (Ortszeit) als ISO-Zeit, leer bei leerem Feld */
export const toIso = (local: string): string | undefined => (local ? new Date(local).toISOString() : undefined);
/** ISO-Zeit als Wert für das Feld „Datum und Uhrzeit“ in der Ortszeit */
export const toLocalInput = (iso: unknown): string => {
  if (typeof iso !== 'string' || !iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
export const nowLocal = () => toLocalInput(new Date().toISOString());

export const errorText = (e: unknown, fallback: string) => (e instanceof ApiError ? (e.status === 422 ? (Object.values(e.fields)[0] ?? e.message) : e.message) : fallback);

/** Kurzbeschreibung eines Eintrags für Listen */
export function summary(e: RidebookEntry): string {
  const p = e.payload;
  switch (e.kind) {
    case 'received':
      return `${text(p.passengerName) || 'Fahrgast fehlt'}: ${text(p.pickupAddress) || '?'} → ${text(p.destinationAddress) || '?'}`;
    case 'assigned':
      return `${text(p.plate)} · ${text(p.driverName)}`;
    case 'started':
      return `Fahrtbeginn ${when(p.startedAt)}`;
    case 'finished':
      return `Fahrtende ${when(p.finishedAt)}${typeof p.priceCents === 'number' ? ` · ${euro(p.priceCents)}` : ''}`;
    case 'cancelled':
      return text(p.reason);
    default:
      return text(p.text);
  }
}
